const RENDER_CRASH_EVENT_NAME = 'eag-render-crash';

export interface RenderCrashDetail {
  name: string;
  message: string;
  stack?: string;
  componentStack?: string;
  /** Set only when Sentry is enabled, so a report never links to an event that was never sent. */
  sentryEventId?: string;
}

declare global {
  interface WindowEventMap {
    [RENDER_CRASH_EVENT_NAME]: CustomEvent<RenderCrashDetail>;
  }
}

export const dispatchRenderCrashEvent = (detail: RenderCrashDetail) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent<RenderCrashDetail>(RENDER_CRASH_EVENT_NAME, {detail}));
};

export const subscribeToRenderCrashEvent = (
  onRenderCrash: (detail: RenderCrashDetail) => void
): VoidFunction => {
  const handleRenderCrashEvent = (event: WindowEventMap[typeof RENDER_CRASH_EVENT_NAME]) =>
    onRenderCrash(event.detail);

  window.addEventListener(RENDER_CRASH_EVENT_NAME, handleRenderCrashEvent);
  return () => window.removeEventListener(RENDER_CRASH_EVENT_NAME, handleRenderCrashEvent);
};
